import {Category, CheckLibs} from '@digital-supply-chain/module'
import {TreeService,CommonService,UserService} from '@/service'

export const ldData = [{"Md5":"55aafcfc188ad19ee081bce57354e040","Params":"{\"SkuName\":\"M12×40\",\"FileName\":\"内六角圆柱头螺钉[M12×40]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"螺纹规格(d)\",\"ItemValue\":\"M12\"},{\"ItemID\":3,\"ItemName\":\"公称长度(l)\",\"ItemValue\":\"40\"},{\"ItemID\":5,\"ItemName\":\"材料\",\"ItemValue\":\"不锈钢\"},{\"ItemID\":7,\"ItemName\":\"机械性能等级\",\"ItemValue\":\"A2-70\"}],\"NationalMark\":\"GB／T 70.1-2008\"}","ProdID":160607000330},{"Md5":"bf310ce9e42b85258c730069f8622f95","Params":"{\"SkuName\":\"M6×16\",\"FileName\":\"内六角沉头螺钉[M6×16]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"螺纹规格(d)\",\"ItemValue\":\"M6\"},{\"ItemID\":3,\"ItemName\":\"公称长度(l)\",\"ItemValue\":\"16\"},{\"ItemID\":5,\"ItemName\":\"性能等级\",\"ItemValue\":\"8.8\"}],\"NationalMark\":\"GB／T 70.3-2008\"}","ProdID":160608000446},{"Md5":"2992811ce1ae625b6d178bce57bd6e54","Params":"{\"SkuName\":\"M6×16\",\"FileName\":\"内六角平圆头螺钉[M6×16]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"螺纹规格(d)\",\"ItemValue\":\"M6\"},{\"ItemID\":3,\"ItemName\":\"公称长度(l)\",\"ItemValue\":\"16\"},{\"ItemID\":5,\"ItemName\":\"性能等级\",\"ItemValue\":\"8.8\"}],\"NationalMark\":\"GB／T 70.2-2008\"}","ProdID":160608000443},{"Md5":"226efbe937d18e1addec49507a695bd6","Params":"{\"SkuName\":\"M5×10\",\"FileName\":\"内六角平端紧定螺钉[M5×10]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"螺纹规格(d)\",\"ItemValue\":\"M5\"},{\"ItemID\":3,\"ItemName\":\"公称长度(l)\",\"ItemValue\":\"10\"},{\"ItemID\":5,\"ItemName\":\"材料\",\"ItemValue\":\"不锈钢\"},{\"ItemID\":7,\"ItemName\":\"机械性能等级\",\"ItemValue\":\"A1-12H\"}],\"NationalMark\":\"GB／T 77-2007\"}","ProdID":160608000009}];

export const lmData = [{"Md5":"0b4f7bd4f5d6d7cc51396cd2f55119e9","Params":"{\"SkuName\":\"M10\",\"FileName\":\"1型六角螺母 A级和B级[M10]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"螺纹规格(D)\",\"ItemValue\":\"M10\"},{\"ItemID\":3,\"ItemName\":\"材料\",\"ItemValue\":\"不锈钢\"},{\"ItemID\":5,\"ItemName\":\"产品等级\",\"ItemValue\":\"A\"}],\"NationalMark\":\"GB／T 6170-2000\"}","ProdID":160607000271}];

export const lsData = [{"Md5":"1816f3693f55951c5689265176f167fb","Params":"{\"SkuName\":\"M5×30\",\"FileName\":\"六角头螺栓[M5×30]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"螺纹规格(d)\",\"ItemValue\":\"M5\"},{\"ItemID\":3,\"ItemName\":\"公称长度(l)\",\"ItemValue\":\"30\"},{\"ItemID\":5,\"ItemName\":\"材料\",\"ItemValue\":\"不锈钢\"},{\"ItemID\":7,\"ItemName\":\"性能等级\",\"ItemValue\":\"A2-70\"}],\"NationalMark\":\"GB／T 5782-2016\"}","ProdID":190228000034}];

export const txdqData = [{"Md5":"1f77f6f84455d5c1098d8fd47b827db5","Params":"{\"SkuName\":\"55\",\"FileName\":\"轴用弹性挡圈A型(d0≥10)[55]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"轴径d0\",\"ItemValue\":\"55\"}],\"NationalMark\":\"GB／T 894.1-1986\"}","ProdID":160609000160},{"Md5":"7b464fd2544633a688184b72771fd217","Params":"{\"SkuName\":\"32\",\"FileName\":\"孔用弹性挡圈A型[32]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"孔径d0\",\"ItemValue\":\"32\"}],\"NationalMark\":\"GB／T 893.1-1986\"}","ProdID":160608000634}];

export const dqData = [{"Md5":"fbb33ebf51863bd1eabc4f1b545b0cd6","Params":"{\"SkuName\":\"8\",\"FileName\":\"平垫圈 倒角型 A级[8]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"规格(螺纹大径)\",\"ItemValue\":\"8\"}],\"NationalMark\":\"GB／T 97.2-2002\"}","ProdID":160608000612},{"Md5":"e13c4ce14cab36a1f7a66a43f53ccb10","Params":"{\"SkuName\":\"10\",\"FileName\":\"标准型弹性垫圈(装配)[10]\",\"LectoParams\":[{\"ItemID\":1,\"ItemName\":\"规格(螺纹大径)\",\"ItemValue\":\"10\"}],\"NationalMark\":\"GB／T 93-1987\"}","ProdID":160608000622}];

export async function AutoCreateLectoDir() {
  const dirList = await TreeService.get(0, Category.LectoFavoriteDir);
  if (dirList.length > 0) {
    return;
  }

  console.log('开始默认目录的创建')

  // 一级目录
  const oneLevel = await TreeService.insert(Category.LectoFavoriteDir, '0', '标准件', '');
  await TreeService.insert(Category.LectoFavoriteDir, '0', '外购件', '');
  await TreeService.insert(Category.LectoFavoriteDir, '0', '企标件', '');
  if (!oneLevel) return false;

  // 标准件二级目录
  const twoLevel = await TreeService.insert(Category.LectoFavoriteDir, oneLevel, '紧固件', '');
  if (!twoLevel) return false;

  // 标准件三级目录
  let ldDirId = 0;
  let lmDirId = 0;
  let lsDirId = 0;
  let txdqDirId = 0;
  let dqDirId = 0;
  try {
    ldDirId = await TreeService.insert(Category.LectoFavoriteDir, twoLevel, '螺钉', '');
    lmDirId = await TreeService.insert(Category.LectoFavoriteDir, twoLevel, '螺母', '');
    lsDirId = await TreeService.insert(Category.LectoFavoriteDir, twoLevel, '螺栓', '');
    txdqDirId = await TreeService.insert(Category.LectoFavoriteDir, twoLevel, '弹性挡圈', '');
    dqDirId = await TreeService.insert(Category.LectoFavoriteDir, twoLevel, '垫圈', '');
  } catch (error) {}

  let lectoArr: any = [];

  [
    { id: ldDirId, data: ldData },
    { id: lmDirId, data: lmData },
    { id: lsDirId, data: lsData },
    { id: txdqDirId, data: txdqData },
    { id: dqDirId, data: dqData },
  ].forEach(item => {
    item.data.forEach(v => {
      lectoArr.push(CommonService.add(Category.LectoFavoriteDir, Category.Outsourcing, item.id, v));
    })
  })

  Promise.all(lectoArr).then(res => {
    window.location.reload();
  })

}

export function TreeArrData(isCompMember = false) {
  if ((CheckLibs.isBigEngineerE() || CheckLibs.isGreatCraftsmanEnt()) && isCompMember) {
     return [
      {
        categoryType: 'EnterpriseShare',
        categoryId: Category.EnterpriseShare,
        defaultNode: [
          {DirName: '企业供应链', DirID: 0, TreeID: 'list_0'},
        ],
      },
      {
        categoryType: 'EnterpriseDir',
        categoryId: Category.EnterpriseDir,
        defaultNode: [
          {DirName: '授权供应链', DirID: -1, TreeID: 'list_-1'},
          {DirName: '我的供应链', DirID: 0, TreeID: 'list_0'},
        ],
      },
      {
        categoryType: 'LectoFavoriteDirShare',
        categoryId: Category.LectoFavoriteDirShare,
        defaultNode: [
          {DirName: '企业零配件', DirID: 0, TreeID: 'list_0'},
        ],
      },
      {
        categoryType: 'LectoFavoriteDir',
        categoryId: Category.LectoFavoriteDir,
        defaultNode: [
          {DirName: '授权零配件', DirID: -1, TreeID: 'list_-1'},
          {DirName: '我的零配件', DirID: 0, TreeID: 'list_0'}
        ],
      },
      {
        categoryType: 'ProdDir',
        categoryId: Category.ProdDir,
        defaultNode: [
          {DirName: '自有零配件', DirID: 0, TreeID: 'list_0'}
        ],
      },
    ];
  }
  return [
    {
      categoryType: 'EnterpriseDir',
      categoryId: Category.EnterpriseDir,
      defaultNode: [{DirName: '我的供应链', DirID: 0, TreeID: 'list_0'}],
    },
    {
      categoryType: 'LectoFavoriteDir',
      categoryId: Category.LectoFavoriteDir,
      defaultNode: [{DirName: '常用零配件', DirID: 0, TreeID: 'list_0'}],
    }
  ];
}
